import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { BehaviorSubject, Observable, switchMap } from 'rxjs';
import { environment } from '../../../environments/environment';
import { GroupDto, UpdateGroupDto } from '@oracychampions/api-interfaces';

@Injectable({
  providedIn: 'root',
})
export class GroupsService {
  private http = inject(HttpClient);

  refresh$ = new BehaviorSubject(null);

  reloadGroups() {
    this.refresh$.next(null);
  }

  getGroups(): Observable<GroupDto[]> {
    return this.refresh$.pipe(switchMap(() => this.http.get<GroupDto[]>(`${environment.API}/groups`)));
  }

  createGroup(school: UpdateGroupDto): Observable<GroupDto[]> {
    return this.http.post<GroupDto[]>(`${environment.API}/groups`, school);
  }

  updateGroup(id: string, school: UpdateGroupDto): Observable<GroupDto[]> {
    return this.http.patch<GroupDto[]>(`${environment.API}/groups/${id}`, school);
  }

  deleteGroup(id: string): Observable<any> {
    return this.http.delete<GroupDto[]>(`${environment.API}/groups/${id}`);
  }
}
